export const MESSAGE_LISTE_SUCCES = "MESSAGE_LISTE_SUCCES";
export const MESSAGE_LISTE_ECHEC = "MESSAGE_LISTE_ECHEC";
export const MESSAGE_LISTE_RESET = "MESSAGE_LISTE_RESET";
export const MESSAGE_LISTE_REQUETTE = "MESSAGE_LISTE_REQUETTE";

export const MESSAGE_CREE_SUCCES = "MESSAGE_CREE_SUCCES";
export const MESSAGE_CREE_ECHEC = "MESSAGE_CREE_ECHEC";
export const MESSAGE_CREE_REQUETTE = "MESSAGE_CREE_REQUETTE";


export const MESSAGE_SUPP_SUCCES = "MESSAGE_SUPP_SUCCES";
export const MESSAGE_SUPP_ECHEC = "MESSAGE_SUPP_ECHEC";
export const MESSAGE_SUPP_REQUETTE = "MESSAGE_SUPP_REQUETTE";
